module.exports = __webpack_public_path__ + "media/images/sort_both-49fb17ab590f2fdc4239d0228db59ff3.png";